import { useDispatch, useSelector } from 'react-redux';

import {
  loggedUserIdSelector,
  targetUserIdSelector,
} from '../../../../redux/context/selectors';
import * as historicMeasurements from '../../../../redux/profiles/patientHealthboard/historic-measurements-req';
import { selectHistoricMeasurementsPreviousDate } from '../../../../redux/profiles/patientHealthboard/selectors';

export const useHistoryActions = ({ type }) => {
  const dispatch = useDispatch();

  const targetUserId = useSelector(targetUserIdSelector);
  const loggedUserId = useSelector(loggedUserIdSelector);
  const previousDate = useSelector(selectHistoricMeasurementsPreviousDate);

  const userId = targetUserId || loggedUserId;

  const loadHistory = () =>
    dispatch(
      historicMeasurements.actions.send({
        userId,
        typeMeasurements: type,
        periodStartDate: previousDate,
      }),
    );

  return { loadHistory };
};



// WEBPACK FOOTER //
// ./src/components/common/Charts/hooks/useHistoryActions.js